import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Plus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail2Plus"><Path d="M12 19.5H2.5V4.5H21.5L21.5 7.25L12 12.0714L2.73768 7.37063" stroke="currentColor"/><Path d="M16 17.5H23M19.5 14V21" stroke="currentColor"/></CentralIconBase>;
});

export default IconEmail2Plus;
